import {OnboardingFlow} from "../models/OnboardingFlow";

export const getMockOnboardingFlow = (): OnboardingFlow => ({
    questions: [
        {
            id: 1,
            text: "What interests you most?",
            answers: [
                { id: 101, text: "Programming", icon: "CODE" },
                { id: 102, text: "Design", icon: "PAINT_BRUSH" },
                { id: 103, text: "AI & Machine Learning", icon: "ROBOT" },
                { id: 104, text: "Business & Strategy", icon: "CHART_LINE" },
            ],
        },
        {
            id: 2,
            text: "What kind of problems do you like to solve?",
            answers: [
                { id: 201, text: "Puzzles & Logic", icon: "PUZZLE_PIECE" },
                { id: 202, text: "User Experience", icon: "PAINT_BRUSH" },
                { id: 203, text: "Automation & Efficiency", icon: "ROBOT" },
                { id: 204, text: "Team Collaboration", icon: "USERS" },
            ],
        },
    ],
});